import React, { type CSSProperties, type ReactNode, useId } from 'react';

import { Icons } from 'widget/components';
import { useIsPrimaryDark } from 'widget/hooks';

interface CheckboxProps {
  isChecked: boolean;
  label: ReactNode;
  onChange: (value: boolean) => void;
  style?: CSSProperties;
}

const Checkbox = ({ isChecked, label, onChange, style }: CheckboxProps) => {
  const id = useId();
  const isPrimaryDark = useIsPrimaryDark();

  return (
    <label className="whatcrm-widget-checkbox" style={style} htmlFor={id}>
      <input
        checked={isChecked}
        id={id}
        onChange={({ target }) => onChange(target.checked)}
        style={{ display: 'none' }}
        type="checkbox"
      />

      <div className="whatcrm-widget-checkbox__input">
        <Icons.Check
          className="whatcrm-widget-checkbox__icon"
          fill={isPrimaryDark ? 'white' : 'dark'}
          size={20}
        />
      </div>

      <span>{label}</span>
    </label>
  );
};

export default Checkbox;
